export function formatAddress(address: string, city: string, postalCode: string | number) {
    if (!address && !city && !postalCode) {
        return '';
    }

    let result = address;
    if (postalCode || city) {
        result += ',';
        if (postalCode) {
            result += ' ' + postalCode;
        }
        if (city) {
            result += ' ' + city;
        }
    }
    return result;
}
